<template>
  <dp-spaces-header />
  <w-layout>
    <w-layout-main>
      <w-spacer
        top="xlarge"
        bottom="large"
        horizontal="small"
      >
        <w-spacer bottom="small">
          <bread-crumb v-if="showBreadcrumbs" />
        </w-spacer>
        <router-view />
      </w-spacer>
    </w-layout-main>
  </w-layout>
</template>

<script setup lang="ts">
import { WLayout, WLayoutMain, WSpacer } from '@dp-watson-web/components';

import DpSpacesHeader from '@/features/noa-space/components/DpSpacesHeader.vue';
import BreadCrumb from '@/shared/layouts/base/components/BreadCrumb.vue';
import { useRouterBreadcrumb } from '@/shared/layouts/base/composables';

const { showBreadcrumbs } = useRouterBreadcrumb();
</script>

<style scoped></style>
